import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'next-i18next';
import Image from 'src/components/atoms/image';
import NextLink from 'src/components/atoms/link';

import { CourseCardContainer, ImageWrapper, Button, Title } from './style';

import { useBreakpointV2 } from '@helpers/use';
import { getAssetUrl } from '@helpers/utils';

interface CourseCardProps {
  isActive: boolean;
  degreeName: string;
  majorSubject: string;
  majorName: string;
  degree: string;
  coursePreview: string;
  courseUrl?: string;
  universityIdName?: string;
}

export const CourseCard = ({
  isActive,
  degreeName,
  majorSubject,
  majorName,
  degree,
  coursePreview,
  courseUrl,
  universityIdName,
}: CourseCardProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { isMobile, isDesktop } = useBreakpointV2();

  return (
    <CourseCardContainer>
      <Box width="auto">
        <ImageWrapper>
          <Image alt="Course Card" src={coursePreview} errorImage={`${getAssetUrl('thumbnail-course-card.jpg')}`} />
        </ImageWrapper>
      </Box>
      <Box
        display="flex"
        width="100%"
        flex={1}
        flexDirection={{
          xs: 'column',
          md: 'column',
          lg: 'row',
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          width={{ lg: '565px', md: '374px', xs: '100%' }}
          height={{ lg: 'unset', md: '105px', sm: 'unset' }}
        >
          <Box display="flex" justifyContent="space-between" flex={1} height="fit-content">
            <Box height="fit-content">
              <Title>
                {t('academic_landing_page.course_section.course_program', { degreeName })}
                <br />
                {majorName} {majorSubject}
              </Title>
              <Typography
                variant="h6_deprecated"
                fontWeight="normal"
                color={theme.palette.grey[700]}
                style={{ fontFamily: theme.typography.h4lanna.fontFamily }}
                marginTop={1}
                marginBottom={{ xs: 2, sm: 0 }}
              >
                {t('academic_landing_page.course_section.degree', { degree })}
              </Typography>
            </Box>
          </Box>
          {isDesktop && (
            <Typography
              variant="h6_deprecated"
              fontWeight={600}
              color={isActive ? theme.palette.secondaryCPD.main : theme.palette.textV2.disabled}
            >
              {isActive
                ? t('academic_landing_page.course_section.course_active')
                : t('academic_landing_page.course_section.course_study_soon')}
            </Typography>
          )}
        </Box>
        {!isDesktop && (
          <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            alignItems={{ lg: 'flex-start', md: 'flex-end', sm: 'flex-end' }}
            justifyContent="space-between"
            height="100%"
            gap={{ xs: '16px', md: 'unset' }}
          >
            <Typography
              variant="h6_deprecated"
              fontWeight={600}
              color={isActive ? theme.palette.secondaryCPD.main : theme.palette.textV2.disabled}
            >
              {isActive
                ? t('academic_landing_page.course_section.course_active')
                : t('academic_landing_page.course_section.course_study_soon')}
            </Typography>
            {!isDesktop && isActive && (
              <Box display="flex" width={{ xs: '100%', sm: 'unset' }}>
                <NextLink href={`${universityIdName}/degree/${courseUrl}`} width={isMobile ? '100%' : 'unset'}>
                  <Button>
                    <Typography variant="button_deprecated" fontWeight={600}>
                      {t('academic_landing_page.course_section.button')}
                    </Typography>
                  </Button>
                </NextLink>
              </Box>
            )}
          </Box>
        )}
        {isDesktop && isActive && (
          <Box display="flex" alignItems="center">
            <NextLink href={`${universityIdName}/degree/${courseUrl}`} width="100%">
              <Button>
                <Typography variant="button_deprecated" fontWeight={600}>
                  {t('academic_landing_page.course_section.button')}
                </Typography>
              </Button>
            </NextLink>
          </Box>
        )}
      </Box>
    </CourseCardContainer>
  );
};
